import React, { useEffect, useState } from "react";
import { printProductLabels } from "../../../utils/productLabelPrint";

const LabelPrinter = ({ selectedProducts, onPrintComplete }) => {
  const [isPrinting, setIsPrinting] = useState(false);
  const [printRequested, setPrintRequested] = useState(false);

  const handlePrintLabels = async () => {
    try {
      setIsPrinting(true);

      const labels = selectedProducts.map((product) => ({
        sku: product.sku_id ?? product.sku ?? "",
        ean: product.ean_id ?? product.ean ?? "",
        name: product.name,
        isMultipack: Boolean(product.isMultipack),
      }));

      await printProductLabels(labels);

      setIsPrinting(false);
      setPrintRequested(false);
      onPrintComplete?.();
    } catch (error) {
      console.error("Error during print process:", error);
      setIsPrinting(false);
      setPrintRequested(false);
      onPrintComplete?.(error);
    }
  };

  useEffect(() => {
    if (selectedProducts?.length && !isPrinting && !printRequested) {
      setPrintRequested(true);
      handlePrintLabels();
    }
  }, [selectedProducts, isPrinting, printRequested]);

  return null;
};

export default LabelPrinter;
